export default __webpack_public_path__ + "static/media/ISMO CLASS-8 EXAM PATTERN 2026-27.65de040c.pdf";